import { Filler } from '../../types/publisherPaginationSettings';
import { SpacerData } from '../../enums/Spacer';

export const LEE_DEFAULT_PAGINATION_FILLERS: Filler[] = [
  {
    id: `${SpacerData.notice.thick.prefix}-3`,
    name: 'Three Col Legals Pill',
    pdfUrl:
      'https://enotice-production.imgix.net/custom-documents%2Fpermalink%2F9a86.d90a2-thick_header.jpg',
    columns: 3,
    height: 50,
    maxOccurrences: 1
  },
  {
    id: `${SpacerData.notice.thick.prefix}-2`,
    name: 'Two Col Legals Pill',
    pdfUrl:
      'https://enotice-production.imgix.net/custom-documents%2Fpermalink%2F9a86.d90a2-thick_header.jpg',
    columns: 2,
    height: 30,
    maxOccurrences: 2
  },
  {
    id: `${SpacerData.notice.thick.prefix}-1`,
    name: 'One Col Legals Pill',
    pdfUrl:
      'https://enotice-production.imgix.net/custom-documents%2Fpermalink%2F9a86.d90a2-thick_header.jpg',
    columns: 1,
    height: 20,
    maxOccurrences: 2
  },
  {
    id: `${SpacerData.notice.super_skinny.prefix}-1`,
    name: 'Three Col Legals Pill super skinny',
    pdfUrl:
      'https://enotice-production.imgix.net/custom-documents%2Fpermalink%2F1169.f2e48-3-col-spacer.jpg',
    columns: 3,
    height: 10,
    maxOccurrences: 2
  },
  {
    id: `${SpacerData.notice.super_skinny.prefix}-2`,
    name: 'Two Col Legals Pill super skinny',
    pdfUrl:
      'https://enotice-production.imgix.net/custom-documents%2Fpermalink%2F1169.f2e48-3-col-spacer.jpg',
    columns: 2,
    height: 10,
    maxOccurrences: 2
  }
];

export const LEE_DEFAULT_PAGINATION_HEADERS = [
  {
    id: 'skinny-spacer',
    name: 'Legals Header',
    url: 'https://enotice-production.imgix.net/custom-documents%2Fpermalink%2Fd600.7a390-skinny_header.jpg',
    dimensions: { width: 928, height: 127 }
  }
];
